import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  templatesMaltaEnAdmissionCoursesSettings,
  templatesMaltaEnStudentCoursesSettings,
  templatesMaltaEnStudentSecondCoursesSettings,
  templatesMaltaEnStudentThirdCoursesSettings,
} from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";

/** Extend when Student Letter exists for other countries. */
export type StudentLetterBasicCountry = Extract<AdmissionOfficeCountry, "malta">;

export type StudentLetterBasicRegistryEntry = {
  admissionCourses: typeof templatesMaltaEnAdmissionCoursesSettings;
  studentCourses: typeof templatesMaltaEnStudentCoursesSettings;
  studentSecondCourses: typeof templatesMaltaEnStudentSecondCoursesSettings;
  studentThirdCourses: typeof templatesMaltaEnStudentThirdCoursesSettings;
};

export const STUDENT_LETTER_BASIC_REGISTRY: Record<StudentLetterBasicCountry, StudentLetterBasicRegistryEntry> = {
  malta: {
    admissionCourses: templatesMaltaEnAdmissionCoursesSettings,
    studentCourses: templatesMaltaEnStudentCoursesSettings,
    studentSecondCourses: templatesMaltaEnStudentSecondCoursesSettings,
    studentThirdCourses: templatesMaltaEnStudentThirdCoursesSettings,
  },
};
